module.exports = __webpack_public_path__ + "static/img/icon6.8c6c18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon6.png
// module id = /07+
// module chunks = 6